import { memo } from 'react';

interface ToastMessageProps {
  title: string;
  message: string;
}

export const ToastMessage = memo(({ title, message }: ToastMessageProps) => {
  return (
    <div>
      <h1 className="text-bolt-elements-textPrimary font-medium">{title}</h1>
      <div className="text-bolt-elements-textSecondary">{message}</div>
    </div>
  );
});
